import React, { PropTypes, Component } from 'react';

import 'styles/details.scss';

// images
import Couple from 'img/couple.jpg';
import Friends from 'img/friends.jpg';
import Night from 'img/night.jpg';

class Details extends Component {
    render () {
        return (
            <div className="section details">
              <div className="container">
                <div className="header">
                  <h2>Achive Your Full Potential</h2>
                </div>
                <div className="body">
                  <ul className="benefits">
                    <li className="benefit">
                      <div className="benefit-image benefit-left">
                        <img src={Night} alt="Blue tree against night sky"/>
                      </div>
                      <div className="benefit-description benefit-right">
                        <h4>Experience a more balanced and positive mood</h4>
                        <p>
                          I can help you identify and change distorted thought patterns
                          helping you to attain more positive and balanced moods.
                          I approach much of my work using the Cognitive
                          Behavioral Therapy (CBT) model.
                        </p>
                      </div>
                    </li>
                    <li className="benefit">
                      <div className="benefit-image benefit-right">
                        <img src={Friends} alt="Tree in the desert"/>
                      </div>
                      <div className="benefit-description benefit-left">
                        <h4>Enjoy more stable and rewarding friendships</h4>
                        <p>
                          I can help you improve your motivation to follow through with
                          personal goals including better relationships, career, health, and enjoyment.
                        </p>
                      </div>
                    </li>
                    <li className="benefit">
                      <div className="benefit-image benefit-left">
                        <img src={Couple} alt="Couple playing in room" />
                      </div>
                      <div className="benefit-description benefit-right">
                        <h4>Build rich romatic partnerships</h4>
                        <p>
                          I work alongside clients to help them build their coping skills,
                          and learn to build positive and rewarding relationships.
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
        );
    }
}

export default Details;



/** WEBPACK FOOTER **
 ** ./src/components/LandingPage/Details.js
 **/